import gql from 'graphql-tag'

export default gql`
	mutation ($name: String, $token: String, $userId: String) {
		createListzoom(record: { name: $name, userId: $userId, token: $token }) {
			recordId
		}
	}
`
